import { TranslationPack } from "../lib/types";

export async function loadCheckin(locale: string): Promise<TranslationPack> {
  switch (locale) {
    case "en_us":
      return (await import("./checkin.en_us")).checkin_en_us();
    case "de_de":
      return (await import("./checkin.de_de")).checkin_de_de();
  }
}